import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import client from '../contentful';
import './Work.css';

function Work({ type = 'work' }) {
  const { title: id } = useParams();
  const [work, setWork] = useState(null);
  const [allWorks, setAllWorks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setWork(null);

    if (type === 'project') {
      const query = `{
        projectCollection {
          items {
            sys { id }
            title
            year
            location
            description { json }
            imagesCollection {
              items { url }
            }
          }
        }
      }`;

      window.fetch(`https://graphql.contentful.com/content/v1/spaces/1rl1jlxxxe6l/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer 45CfDXmLKyusG7xKSwYwBDNTqyV0EcQdgWKMi6MxNPQ",
        },
        body: JSON.stringify({ query }),
      })
        .then((response) => response.json())
        .then(({ data, errors }) => {
          if (errors) { console.error(errors); setLoading(false); return; }
          const items = data.projectCollection.items;
          setAllWorks(items);
          const found = items.find((p) => p.sys.id === id);
          setWork(found);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
    } else {
      client.getEntries({ content_type: 'work', order: '-fields.worksPageSequence' })
        .then((response) => {
          setAllWorks(response.items);
          const found = response.items.find(w => w.sys.id === id);
          setWork(found);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
    }
  }, [id, type]);

  if (loading) return <div>Loading...</div>;
  if (!work) return <div>Work not found.</div>;

  const isProject = type === 'project';
  const title = isProject ? work.title : work.fields.title;
  const year = isProject ? work.year : work.fields.year;
  const materials = isProject ? work.location : work.fields.materials;
  const dimensions = isProject ? '' : work.fields.dimensions;
  const images = isProject
    ? (work.imagesCollection?.items || []).map(img => ({ url: img.url }))
    : (work.fields.images || []).map(img => ({ url: 'https:' + img.fields.file.url }));
  const description = isProject ? work.description?.json : work.fields.description;

  const currentIndex = allWorks.findIndex(w => w.sys.id === id);
  const prevWork = allWorks[currentIndex - 1];
  const nextWork = allWorks[currentIndex + 1];
  const basePath = isProject ? '/project/' : '/work/';

  return (
    <div className="work-page">
      {prevWork && (
        <a href={basePath + prevWork.sys.id} className="work-nav-fixed prev work-nav-link">← prev</a>
      )}
      {nextWork && (
        <a href={basePath + nextWork.sys.id} className="work-nav-fixed next work-nav-link">next →</a>
      )}
      <div className="work-main">
        <div className="work-left">
          <div className="work-images">
            {images.map(function(img, i) {
              return (
                <img key={i} src={img.url} alt={title} />
              );
            })}
          </div>
        </div>
        <div className="work-right">
          <p className="work-detail-title">
  {title}<span className="work-detail-year">, {year}</span>
</p>
          {materials && <p className="work-detail-meta">{materials}</p>}
          {dimensions && <p className="work-detail-meta">{dimensions}</p>}
          {description && (
            <div className="work-detail-description">
              {description.content.map(function(block, i) {
                return <p key={i}>{block.content.map(function(c) { return c.value; }).join('')}</p>;
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Work;
